import styled from "styled-components";

import { defaultThemeColors, themeFontSize } from "ui/theme";


export const DiscountBadge = ({discount}) => {
    const isFirstClassFree =
        discount?.policy === "First class" &&
        discount?.percentage === 100;

    return (
        <DiscountBadgeWrapper isFirstClassFree={isFirstClassFree}>
            {isFirstClassFree ? 'First class free!' : `${discount?.policy} Discount: ${discount?.percentage}%`}
        </DiscountBadgeWrapper>
    );
};


const DiscountBadgeWrapper = styled.div`
    display: inline-flex;
    width: fit-content;
    align-items: center;
    background: ${({isFirstClassFree})=> isFirstClassFree ? defaultThemeColors.blue : defaultThemeColors.secondary};
    color: ${({isFirstClassFree})=> isFirstClassFree ? defaultThemeColors.white : defaultThemeColors.blue};
    border: 1px solid ${({isFirstClassFree})=> isFirstClassFree ? defaultThemeColors.blue : defaultThemeColors.secondary};
    border-radius: 5px;
    padding: 5px 12px;
    font-weight: 700;
    font-size: 11px;
    text-transform: capitalize;
    margin-top: 6px;
`;



